module.exports = __webpack_public_path__ + "img/chirallogo@2x.bd7f5eb3.png";